import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.scss']
})
export class GaleriaComponent implements OnInit {

  // Lista con las alturas de los contenedores
  alturas = [50, 100, 150, 50, 100, 150, 50, 100, 150, 50, 100, 150, 50, 100, 150];

  columnas = [[], [], []]; // Ahora tres columnas vacías

  constructor() { }

  ngOnInit(): void {
    // Organizar las alturas en 3 columnas
    this.alturas.forEach((altura, index) => {
      const columnaIndex = index % 3;  // Determina en qué columna irá el elemento
      this.columnas[columnaIndex].push(altura);
    });
  }
}
